import { useEffect, useState } from 'react';
import { calculateTimeLeft } from '../helpers';
import { TTimerFormat } from '../types/types';

export const useTimer = (
  targetDate?: string | null,
  disabled?: boolean,
  format?: TTimerFormat,
) => {
  const [timeLeft, setTimeLeft] = useState<string | null>(
    calculateTimeLeft(targetDate, format),
  );

  useEffect(() => {
    if (!targetDate || disabled) {
      return;
    }

    const interval = setInterval(() => {
      setTimeLeft(calculateTimeLeft(targetDate, format));
    }, 1000);

    return () => clearInterval(interval);
  }, [disabled, format, targetDate]);

  return timeLeft;
};
